import React, { useEffect } from 'react';

import {
    selectedPrescripteursSelector,
    TiersAppDispatch,
    useTiersService,
    useTiersServiceSelector,
} from '@europrocurement/l2d-domain';
import { useDispatch } from 'react-redux';
import {
    ParcoursFormaliteProviderType,
    ParcoursFormaliteProvider,
} from './ParcoursFormaliteProvider';

export type PrescriberWrappedParcoursFormaliteProviderType = {
    idPrescripteur: number;
} & Omit<ParcoursFormaliteProviderType, 'prescripteur'>;

export const PrescriberWrappedParcoursFormaliteProvider: React.FunctionComponent<PrescriberWrappedParcoursFormaliteProviderType> =
    function ({ idPrescripteur, children, ...providerProps }) {
        const prescripteur = useTiersServiceSelector(selectedPrescripteursSelector);
        const { selectPrescripteur } = useTiersService();

        const dispatch = useDispatch<TiersAppDispatch>();

        useEffect(() => {
            if (idPrescripteur) {
                if (!prescripteur || prescripteur.id !== idPrescripteur) {
                    dispatch(selectPrescripteur({ id: idPrescripteur }));
                }
            }
        }, [dispatch, idPrescripteur, prescripteur, selectPrescripteur]);

        return prescripteur ? (
            <ParcoursFormaliteProvider
                {...providerProps}
                prescripteur={prescripteur}
                back
            >
                {children}
            </ParcoursFormaliteProvider>
        ) : null;
    };
